/**
 * Shared constants for all audio visualizers (PreJoinVisualizer, BarVisualizer).
 * Ensures consistent appearance across prejoin, room control bar, and agent panel.
 */
export const VISUALIZER_BAR_COUNT = 5;
export const VISUALIZER_BAR_WIDTH = 6;
export const VISUALIZER_GAP = 6;
export const VISUALIZER_BORDER_RADIUS = 4;
export const VISUALIZER_MIN_HEIGHT_PX = 4;
export const VISUALIZER_HEIGHT = 36;
export const VISUALIZER_WIDTH = 60;

/** BarVisualizer uses percentage heights; min ~11%, max 100% to match PreJoin proportions */
export const VISUALIZER_MIN_HEIGHT_PCT = 10;
export const VISUALIZER_MAX_HEIGHT_PCT = 100;
